import React, {useMemo} from 'react';
import styles from '@/components/help/common/FormContainer/FormContainer.module.scss';
import {SoopInputBox} from '@soop-ui/soop-ui';
import {useHelpContext} from '@/app/(main)/routes/help/context/HelpContext';
import {useFormContainerContext} from '@/components/help/common/FormContainer/FormContainerContext';

interface OsInfoProps {
  className?: string;
}

const OsInfo = ({className}: OsInfoProps) => {
  const {isMobile} = useHelpContext();

  const {osName} = useFormContainerContext();

  // 화면에 표시될 간단한 OS 이름
  const displayName = useMemo(() => {
    if (!osName) {
      return '';
    }
    return osName === 'Android' ? '안드로이드' : osName;
  }, [osName]);

  if (!isMobile) {
    return null;
  }

  return (
    <div className={`${styles.section} ${className || ''}`}>
      <label className={styles.label}>OS</label>
      <SoopInputBox
        value={displayName}
        size={44}
        clearable={false}
        disabled
        readOnly
      />
    </div>
  );
};

export default OsInfo;
